<template>
  <div v-if="activeImport" class="active-import" role="status">
    <p class="active-import__text">
      <strong>Import #{{ activeImport.id }} is in progress</strong>
      <import-status-badge compact :status="activeImport.status" />
      <span>Another file can be uploaded after it is applied or cancelled.</span>
    </p>
    <app-button design="new" theme="dark" @click.native="open">Open import</app-button>
  </div>
</template>

<script>
import { getClimbingMountainCrewImports } from '@/http'
import ImportStatusBadge from './ImportStatusBadge'

// Shows the import that blocks new uploads and tells the page about it, so the page can
// disable its "Import crew" button. The backend decides which statuses are active
// (`category=active`) and enforces the same rule on upload.
export default {
  name: 'CrewActiveImportNotice',
  components: { ImportStatusBadge },
  data() {
    return { activeImport: null }
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      return getClimbingMountainCrewImports({
        category: 'active',
        page_size: 1
      }).then(response => {
        this.activeImport = response.data.results[0] || null
      }).catch(() => {
        this.activeImport = null
      }).finally(() => {
        this.$emit('change', this.activeImport)
      })
    },
    open() {
      this.$router.push({
        name: 'climbing-mountain-crew-import-detail',
        params: { importId: this.activeImport.id }
      }).catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
.active-import {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: $ui-space-16;
  margin-bottom: $ui-space-16;
  padding: $ui-space-12 $ui-space-16;
  border: 1px solid $ui-amber;
  border-radius: $ui-panel-radius;
  background-color: $ui-amber-soft;
  color: $ui-text;
  font-family: $ui-font-body;
  font-size: $ui-font-size-body;
  line-height: 1.45;

  &__text {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: $ui-space-8 $ui-space-12;
    margin: 0;
    min-width: 0;

    strong { color: $ui-ink; font-weight: 600; }
  }
}

@media (max-width: 760px) {
  .active-import { flex-direction: column; align-items: stretch; }
}
</style>
